import { ApiClient } from "@/api/ApiClient";
import { PubSubBroadcast } from "./PubSubBroadcast";

export type RefreshDocumentIndexEvent = { modelName: keyof typeof ApiClient.models };

export const DocumentsIndexPubSub = new PubSubBroadcast<RefreshDocumentIndexEvent>(
    "easypos",
    "REFRESH_DOCUMENTS_INDEX"
);